import { Component, OnInit, ChangeDetectionStrategy, inject, viewChild } from '@angular/core';
import { LayoutService } from '../../@vex/services/layout.service';
import { filter, map, startWith } from 'rxjs/operators';
import { NavigationEnd, Router } from '@angular/router';
import { checkRouterChildsData } from '../../@vex/utils/check-router-childs-data';
import { ConfigService } from '../../@vex/config/config.service';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { SidebarComponent } from '../../@vex/components/sidebar/sidebar.component';
import { HeaderComponent } from '../../@vex/layout/header/header.component';
import { SidenavComponent } from '../../@vex/layout/sidenav/sidenav.component';
import { ToolbarComponent } from '../../@vex/layout/toolbar/toolbar.component';
import { QuickpanelComponent } from '../../@vex/layout/quickpanel/quickpanel.component';
import { LayoutComponent } from '../../@vex/layout/layout.component';
import { ConfigPanelComponent } from '../../@vex/components/config-panel/config-panel.component';
import { AsyncPipe } from '@angular/common';

@UntilDestroy()
@Component({
	selector: 'vex-custom-layout',
	templateUrl: './custom-layout.component.html',
	styleUrls: ['./custom-layout.component.scss'],
	changeDetection: ChangeDetectionStrategy.Eager,
	imports: [HeaderComponent, SidenavComponent, ToolbarComponent, QuickpanelComponent, LayoutComponent, SidebarComponent, ConfigPanelComponent, AsyncPipe],
})
export class CustomLayoutComponent implements OnInit {
	private layoutService = inject(LayoutService);
	private configService = inject(ConfigService);
	private router = inject(Router);

	sidenavCollapsed$ = this.layoutService.sidenavCollapsed$;
	isFooterVisible$ = this.configService.config$.pipe(map((config) => config.footer.visible));
	isDesktop$ = this.layoutService.isDesktop$;

	toolbarShadowEnabled$ = this.router.events.pipe(
		filter((event) => event instanceof NavigationEnd),
		startWith(null),
		map(() => checkRouterChildsData(this.router.routerState.root.snapshot, (data) => data.toolbarShadowEnabled))
	);

	readonly configpanel = viewChild<SidebarComponent>('configpanel');

	ngOnInit() {
		this.layoutService.configpanelOpen$.pipe(untilDestroyed(this)).subscribe((open) => (open ? this.configpanel().open() : this.configpanel().close()));
		// this.determineRouteByCookie();
	}

	determineRouteByCookie() {
		switch (sessionStorage.getItem('activeView')) {
			case '':
				return this.router.navigate(['/dashboard']);
			case '/tenantunit':
				if (sessionStorage.getItem('selectedRealEstateID')) {
					return this.router.navigate(['/tenantunit/' + sessionStorage.getItem('selectedRealEstateID')]);
				}
				return this.router.navigate(['/billingunit']);
			case '/tenantunitdetail':
				if (sessionStorage.getItem('selectedRealEstateID')) {
					if (sessionStorage.getItem('selectedTenantUnitID')) {
						return this.router.navigate(['/tenantunitdetail/' + sessionStorage.getItem('selectedTenantUnitID')]);
					}
				}
				return this.router.navigate(['/billingunit']);
			default:
				return this.router.navigate([sessionStorage.getItem('activeView')]);
		}
	}
}
